import {
  Component,
  OnInit,
  ElementRef,
  Input
} from "@angular/core";
import { DialogService } from "../dialog";
import { DialogComponent } from "../dialog/dialog.component";

export interface ConfirmModel1 {
  title: string;
  reportServerUrl: string;
  reportPath: string;
  parametersList: any;
}

@Component({
  selector: "app-vchrprint",
  templateUrl: "./vchrprint.component.html",
  styleUrls: ["./vchrprint.component.css"]
})
export class VchrprintComponent extends DialogComponent<ConfirmModel1, boolean>
  implements ConfirmModel1, OnInit {
  title: string;
  reportServerUrl: string;
  reportPath: string;
  parametersList: any;
  loading: boolean = false;
  result: any;
  private el: ElementRef;
  @Input() onReturn: string;

  constructor(dialogService: DialogService) {
    super(dialogService);
  }
  reportServer: string = "http://myreportserver/reportserver";
  reportUrl: string = "MyReports/SampleReport";
  showParameters: string = "true";
  parameters: any = {};
  language: string = "en-us";
  width: number = 100;
  height: number = 100;
  toolbar: string = "true";
  ngOnInit() {
    this.result = false;
    this.reportServer = this.reportServerUrl;
    this.reportUrl = this.reportPath;
    this.parameters = this.parametersList;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/vchrprint/vchrprint.component.ts